import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';

const Footer = ({ openModal, onContactClick }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const scrollToServices = () => {
    if (location.pathname !== '/') {
      // If not on home page, navigate to home first
      navigate('/');
      setTimeout(() => {
        const servicesSection = document.querySelector('.section');
        if (servicesSection) {
          servicesSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 100);
    } else {
      // If already on home page, just scroll
      const servicesSection = document.querySelector('.section');
      if (servicesSection) {
        servicesSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  };

  return (
    <footer>
      <div className="footer-container">
        <div className="footer-about">
          <h3>Greenbucks Engineering Solution</h3>
          <p>Building digital excellence through innovation. We deliver reliable IT solutions and connect businesses with skilled engineering talent.</p>
          <p style={{ marginTop: '1rem' }}>
            📍 Nashik, Maharashtra, India<br />
            <a className='color-white' href="mailto:info@greenbucksengg.com">📧 info@greenbucksengg.com</a><br />
            📞 +91-9130204357
          </p>
        </div>
        <div className="footer-section">
          <h4>Company</h4>
          <ul>
            <li><Link to="/about">About Us</Link></li>
            <li><Link to="/portfolio">Portfolio</Link></li>
            <li><Link to="/jobs">Careers</Link></li>
            <li><Link to="/articles">Blog</Link></li>
          </ul>
        </div>
        <div className="footer-section">
          <h4>Services</h4>
          <ul>
            <li><a href="#services" onClick={(e) => { e.preventDefault(); scrollToServices(); }}>Web Development</a></li>
            <li><a href="#services" onClick={(e) => { e.preventDefault(); scrollToServices(); }}>Mobile Apps</a></li>
            <li><a href="#services" onClick={(e) => { e.preventDefault(); scrollToServices(); }}>Cloud Services</a></li>
            <li><a href="#services" onClick={(e) => { e.preventDefault(); scrollToServices(); }}>IT Staffing</a></li>
          </ul>
        </div>
        <div className="footer-section">
          <h4>Legal</h4>
          <ul>
            <li>
              <button
                className="footer-link"
                onClick={() => openModal('terms')}
              >
                Terms of Service
              </button>
            </li>
            <li>
              <button
                className="footer-link"
                onClick={() => openModal('privacy')}
              >
                Privacy Policy
              </button>
            </li>
          </ul>
        </div>
      </div>
      <div className="footer-bottom">
        <p>&copy; 2025-2026 Greenbucks Engineering Solution. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
